import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../../../assets/css/timeTable.css';
import Loader from "../../Shared/Loader/Loader";
import Toast from '../../Shared/Toast/Toast';
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useNavigate } from 'react-router-dom';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import CommonConfig from '../../../utils/constant';
import moment from 'moment';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { Dialog } from 'primereact/dialog';

const ClassTimeTableCard = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const [isExpanded, setIsExpanded] = useState(false);
    const [timetableData, setTimetableData] = useState([]);
    const [duration, setDuration] = useState('');
    const [interval, setInterval] = useState('');
    const navigate = useNavigate();
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [deleteData, setDeleteData] = useState({});

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        let resData = (props?.ClassConfigurationData || []).find(c => String(c?.ClassId) === String(props?.ClassId)) || {};
        setDuration(resData?.Duration ?? 0);
        setInterval(resData?.Interval ?? 0);
    }, [props?.ClassConfigurationData, props?.ClassId]);

    const GetTimeTableData = async (classId) => {
        try {
            let data = {
                ClassId: classId,
                FinancialYearId: props?.financialYearId,
                UserId: securityUserID
            }
            Loader.show();
            const response = await api.post(APIConstant.path.GetTimeTableListByClass, data);
            if (response?.success) {
                setTimetableData(response?.data);
            } else {
                setTimetableData([]);
                Toast.error({ message: response?.message });
            }
            Loader.hide();
        } catch (error) {
            Loader.hide();
            console.error("Error fetching timetable:", error);
            catchResponse(error);
        }
    };

    const GetTimeTablePrintData = async (classId, startDate, endDate) => {
        try {
            let data = {
                ClassId: classId,
                FinancialYearId: props?.financialYearId,
                UserId: securityUserID,
                StartDate: !CommonConfig.isEmpty(startDate) && startDate !== '-' ? moment(startDate).format("YYYY-MM-DD") : '',
                EndDate: !CommonConfig.isEmpty(endDate) && endDate !== '-' ? moment(endDate).format("YYYY-MM-DD") : '',
            }
            Loader.show();
            const response = await api.post(APIConstant.path.GetTimeTableByClass, data);
            if (response?.success && response?.data?.length > 0) {
                let periodData = response?.data[0]?.Periods?.map((x, idx) => {
                    return { Time: x?.Time, isBreak: x?.SubjectId === 'Break' ? true : false }
                });
                let timeTableData = response.data.map(row => {
                    const formattedRow = { Day: row?.Day, Id: row?.id };
                    row?.Periods?.forEach((period, index) => {
                        formattedRow[`Period${index + 1}`] = period?.SubjectId === 'Break' ? period?.SubjectId : period?.SubjectName;
                        formattedRow[`Teacher${index + 1}`] = period?.TeacherId === 'Break' ? period?.TeacherId : period?.TeacherName;
                        formattedRow[`Parallel${index + 1}`] = (period?.ParallelSubjects || [])
                            .map(ps => ({ subject: ps?.SubjectName || '', teacher: ps?.TeacherName || '' }));
                    });
                    return formattedRow;
                });
                const sortedData = timeTableData.sort((a, b) => {
                    return days.indexOf(a?.Day) - days.indexOf(b?.Day);
                });
                printTimeTable(sortedData, periodData);
            } else {
                Toast.error({ message: response?.message });
            }
            Loader.hide();
        } catch (error) {
            Loader.hide();
            console.error("Error fetching timetable:", error);
            catchResponse(error);
        }
    };

    const toggleExpand = (value) => {
        if (value) {
            GetTimeTableData(props?.ClassId);
        }
        setIsExpanded(value);
    };

    const printTimeTable = (timetablePrintData, periodsData) => {
        try {
            if (timetablePrintData.length === 0) {
                Toast.error({ message: "No data available for printing." });
                return;
            }
            Loader.show();
            const doc = new jsPDF();
            doc.setFontSize(16);
            doc.text(`Time Table for Class: ${props?.ClassName}`, 10, 10);

            const columns = [
                { header: "Days/Periods", dataKey: "Day" },
                ...periodsData?.map((period, index) => ({
                    header: period?.Time,
                    dataKey: `Period${index + 1}`,
                })),
            ];

            const rows = timetablePrintData?.map((row) => {
                const formattedRow = { Day: row?.Day };
                periodsData?.forEach((_, index) => {
                    if (row[`Period${index + 1}`] === 'Break') {
                        formattedRow[`Period${index + 1}`] = row[`Teacher${index + 1}`];
                    } else {
                        let cell = `${row[`Period${index + 1}`]} - ${row[`Teacher${index + 1}`]}`;
                        (row[`Parallel${index + 1}`] || []).forEach((ps) => {
                            if (ps?.subject) cell += `\n${ps.subject} - ${ps.teacher}`;
                        });
                        formattedRow[`Period${index + 1}`] = cell;
                    }
                });
                return formattedRow;
            });

            autoTable(doc, {
                columns: columns,
                body: rows,
                startY: 20,
                theme: "grid",
            });
            Loader.hide();
            doc.save(`Class_Time_Table_${props?.ClassName || "Unknown"}.pdf`);
        } catch (error) {
            console.log('Error ');
            Loader.hide();
        }
    };

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center'>
                    <Button icon="pi pi-pencil" className="e-sction-btn" onClick={() => navigate('/edit-class-time-table', { state: { ClassId: props?.ClassId, financialYearId: props?.financialYearId, academicYearList: props?.academicYearList, startDate: rows?.StartDateRaw, endDate: rows?.EndDateRaw, configId: rows?.id } })} />
                    <Button icon="pi pi-print" className="e-sction-btn p-mx-2" onClick={async () => {
                        await GetTimeTablePrintData(props?.ClassId, rows?.StartDateRaw, rows?.EndDateRaw);
                    }} />
                    <Button icon="pi pi-trash" className="e-sction-btn" onClick={() => {
                        setIsDeleteConfirmation(true);
                        setDeleteData({ StartDateRaw: rows?.StartDateRaw, EndDateRaw: rows?.EndDateRaw });
                    }} />
                </div>
            </React.Fragment>
        );
    };

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => DeleteTimeTable()}
            />
        </div>
    );

    const DeleteTimeTable = async () => {
        try {
            let data = {
                ClassId: props?.ClassId,
                FinancialYearId: props?.financialYearId,
                UserId: securityUserID,
                StartDate: !CommonConfig.isEmpty(deleteData?.StartDateRaw) ? moment(deleteData?.StartDateRaw).format("YYYY-MM-DD") : '',
                EndDate: !CommonConfig.isEmpty(deleteData?.EndDateRaw) ? moment(deleteData?.EndDateRaw).format("YYYY-MM-DD") : '',
            }
            await api.post(APIConstant.path.DeleteClassTimeTable, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Time table deleted successfully' });
                    setDeleteData({});
                    GetTimeTableData(props?.ClassId);
                } else {
                    Toast.error({ message: res?.message });
                }
                handleClose();
            }).catch(err => {
                handleClose();
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    return (
        <div className='time-table'>
            <div className="">
                <h2>{`Class : ${props?.ClassName}`}</h2>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="p-d-flex p-ai-center">
                        <div className='time-table-info'>
                            <h4 className='p-m-0'>Duration minute - </h4>
                            <p className='p-m-0 p-pl-1'>{duration}</p>
                        </div>
                        <div className='time-table-info p-ml-2' style={{ backgroundColor: '#EFEFEF' }}>
                            <h4 className='p-m-0'>Interval minute - </h4>
                            <p className='p-m-0 p-pl-1'> {interval}</p>
                        </div>
                    </div>
                    <div className="p-d-flex p-ai-center p-jc-between">
                        <Button
                            icon={`pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`}
                            className="e-sction-btn"
                            onClick={() => toggleExpand(!isExpanded)}
                        />
                        <Button icon="pi pi-plus" className="e-h-btn p-ml-2" onClick={() => navigate('/edit-class-time-table', { state: { ClassId: props?.ClassId, financialYearId: props?.financialYearId, academicYearList: props?.academicYearList, startDate: "", endDate: "", configId: '' } })} />
                    </div>
                </div>
                {(isExpanded) && (
                    <div className="p-mt-3">
                        <DataTable value={timetableData} responsiveLayout="scroll" className="custom-table" scrollHeight='min-content'>
                            <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." />
                            <Column field="StartDate" header="Start Date" />
                            <Column field="EndDate" header="End Date" />
                            <Column body={actionBodyTemplate} header="Action" headerClassName='e-template-action' bodyClassName='e-template-action' headerStyle={{ display: 'flex', justifyContent: 'end' }} />
                        </DataTable>
                    </div>
                )}
            </div>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div>
    );
};

export default ClassTimeTableCard;
